(function () {
  var sticky = document.querySelector('[data-pdp-sticky-atc]');
  if (!sticky) return;

  var threshold = 800;
  var raf = null;

  function update() {
    if (window.scrollY > threshold) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      update();
      raf = null;
    });
  }, { passive: true });

  var addBtn = sticky.querySelector('[data-sticky-add]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) form.submit();
      var cartIcon = document.querySelector('.v6-nav__cart, [data-cart-icon]');
      if (cartIcon) {
        cartIcon.classList.add('is-pulsing');
        setTimeout(function () { cartIcon.classList.remove('is-pulsing'); }, 600);
      }
    });
  }
})();
